// LOGIN
export const AUTH_LOGIN_REQUEST = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE";
export const AUTH_LOGIN_RESET = "AUTH_LOGIN_RESET";

// LOGOUT
export const AUTH_LOGOUT = "AUTH_LOGOUT_SUCCESS";

// SIGNUP
export const AUTH_REGISTER_REQUEST = "AUTH_REGISTER_REQUEST";
export const AUTH_REGISTER_SUCCESS = "AUTH_REGISTER_SUCCESS";
export const AUTH_REGISTER_FAILURE = "AUTH_REGISTER_FAILURE";
export const AUTH_REGISTER_RESET = "AUTH_REGISTER_RESET";

//isAuthCheck

export const IS_AUTH_CHECK_SUCCESS = "IS_AUTH_CHECK_SUCCESS";
export const IS_AUTH_CHECK_FAILURE = "IS_AUTH_CHECK_FAILURE";

//isAuthCheck

export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";